var _g, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_14_1",
    "data-name": "Component 14 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.295,
    height: 268.408,
    viewBox: "0 0 324.295 268.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71635",
    "data-name": "Group 71635",
    transform: "translate(-856.085 -379.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71632",
    "data-name": "Group 71632",
    transform: "translate(878.11 396.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71622",
    "data-name": "Group 71622",
    transform: "translate(0 7.338)",
    opacity: 0.461
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71620",
    "data-name": "Group 71620",
    transform: "translate(0 30.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27312",
    "data-name": "Rectangle 27312",
    width: 265.794,
    height: 151.633,
    fill: "rgba(114,112,112,0.12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71621",
    "data-name": "Group 71621"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27320",
    "data-name": "Rectangle 27320",
    width: 265.794,
    height: 19.172,
    fill: "rgba(114,112,112,0.12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71623",
    "data-name": "Group 71623",
    transform: "translate(5.219 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71611",
    "data-name": "Group 71611",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71470",
    "data-name": "Group 71470",
    transform: "translate(0 30.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27312-2",
    "data-name": "Rectangle 27312",
    width: 265.794,
    height: 151.633,
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71483",
    "data-name": "Group 71483",
    transform: "translate(9.712 105.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71479",
    "data-name": "Group 71479",
    transform: "translate(11.712 0.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317",
    "data-name": "Rectangle 27317",
    width: 75.522,
    height: 3.014,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71480",
    "data-name": "Group 71480",
    transform: "translate(11.712 12.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27318",
    "data-name": "Rectangle 27318",
    width: 75.522,
    height: 3.014,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71481",
    "data-name": "Group 71481",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M702.718-1094.246h-.172a2.455,2.455,0,0,1-2.455-2.455h0a2.454,2.454,0,0,1,2.455-2.454h.172a2.454,2.454,0,0,1,2.454,2.454h0A2.455,2.455,0,0,1,702.718-1094.246Z",
    transform: "translate(-700.091 1099.155)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71482",
    "data-name": "Group 71482",
    transform: "translate(0 11.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27319",
    "data-name": "Rectangle 27319",
    width: 5.081,
    height: 4.908,
    rx: 2.454,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71672",
    "data-name": "Group 71672",
    transform: "translate(146.712 46.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71479-2",
    "data-name": "Group 71479",
    transform: "translate(-2.288 0.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317-2",
    "data-name": "Rectangle 27317",
    width: 92.847,
    height: 3.014,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71674",
    "data-name": "Group 71674",
    transform: "translate(-2.288 25.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317-3",
    "data-name": "Rectangle 27317",
    width: 92.847,
    height: 3.014,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71676",
    "data-name": "Group 71676",
    transform: "translate(-2.288 39.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317-4",
    "data-name": "Rectangle 27317",
    width: 92.847,
    height: 3.014,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71678",
    "data-name": "Group 71678",
    transform: "translate(-2.288 60.552)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317-5",
    "data-name": "Rectangle 27317",
    width: 46.424,
    height: 10.349,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71679",
    "data-name": "Group 71679",
    transform: "translate(-2.288 74.856)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317-6",
    "data-name": "Rectangle 27317",
    width: 31.802,
    height: 10.349,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71480-2",
    "data-name": "Group 71480",
    transform: "translate(-2.288 7.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27318-2",
    "data-name": "Rectangle 27318",
    width: 92.847,
    height: 3.014,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71673",
    "data-name": "Group 71673",
    transform: "translate(-2.288 32.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27318-3",
    "data-name": "Rectangle 27318",
    width: 92.847,
    height: 3.014,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71675",
    "data-name": "Group 71675",
    transform: "translate(-2.288 46.856)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27318-4",
    "data-name": "Rectangle 27318",
    width: 92.847,
    height: 3.014,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71614",
    "data-name": "Group 71614",
    transform: "translate(9.712 132.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71479-3",
    "data-name": "Group 71479",
    transform: "translate(11.712 0.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27317-7",
    "data-name": "Rectangle 27317",
    width: 75.522,
    height: 3.014,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71480-3",
    "data-name": "Group 71480",
    transform: "translate(11.712 12.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27318-5",
    "data-name": "Rectangle 27318",
    width: 75.522,
    height: 3.014,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71481-2",
    "data-name": "Group 71481",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7327-2",
    "data-name": "Path 7327",
    d: "M702.718-1094.246h-.172a2.455,2.455,0,0,1-2.455-2.455h0a2.454,2.454,0,0,1,2.455-2.454h.172a2.454,2.454,0,0,1,2.454,2.454h0A2.455,2.455,0,0,1,702.718-1094.246Z",
    transform: "translate(-700.091 1099.155)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71482-2",
    "data-name": "Group 71482",
    transform: "translate(0 11.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27319-2",
    "data-name": "Rectangle 27319",
    width: 5.081,
    height: 4.908,
    rx: 2.454,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71484",
    "data-name": "Group 71484"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27320-2",
    "data-name": "Rectangle 27320",
    width: 265.794,
    height: 19.172,
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71491",
    "data-name": "Group 71491",
    transform: "translate(9.757 5.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71486",
    "data-name": "Group 71486",
    transform: "translate(22.361 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71485",
    "data-name": "Group 71485"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 2.76,
    cy: 2.76,
    r: 2.76,
    transform: "translate(0 3.903) rotate(-45)",
    fill: "#67b4d2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71488",
    "data-name": "Group 71488",
    transform: "translate(11.032 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71487",
    "data-name": "Group 71487",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 2.76,
    cy: 2.76,
    r: 2.76,
    transform: "translate(0 3.903) rotate(-45)",
    fill: "#eb908b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71490",
    "data-name": "Group 71490",
    transform: "translate(0 0.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71489",
    "data-name": "Group 71489",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 2.76,
    cy: 2.76,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(0 2.112) rotate(-22.5)",
    fill: "#ffaa3f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71604",
    "data-name": "Group 71604",
    transform: "translate(20.568 161.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27348",
    "data-name": "Rectangle 27348",
    width: 128.413,
    height: 2.801,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71605",
    "data-name": "Group 71605",
    transform: "translate(10.61 160.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M704.773-969.452h0a2.96,2.96,0,0,0-2.96,2.96h0a2.96,2.96,0,0,0,2.96,2.96h0a2.96,2.96,0,0,0,2.96-2.96h0A2.96,2.96,0,0,0,704.773-969.452Z",
    transform: "translate(-701.813 969.452)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71668",
    "data-name": "Group 71668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71471",
    "data-name": "Group 71471",
    transform: "translate(9.915 45.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27313",
    "data-name": "Rectangle 27313",
    width: 88.18,
    height: 49.695,
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M28.487,33.2H0L21.706,6.834l14.487,17.6L57.664,0,86.833,33.2Z",
    transform: "translate(10.693 61.953)",
    fill: "rgba(114,112,112,0.19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71669",
    "data-name": "Group 71669",
    transform: "translate(97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71471-2",
    "data-name": "Group 71471",
    transform: "translate(9.915 45.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27313-2",
    "data-name": "Rectangle 27313",
    width: 25.983,
    height: 13.375,
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M8.394,9.782H0L6.4,2.014,10.664,7.2,16.991,0l8.595,9.782Z",
    transform: "translate(10.144 48.72)",
    fill: "rgba(114,112,112,0.19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71670",
    "data-name": "Group 71670",
    transform: "translate(97 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71471-3",
    "data-name": "Group 71471",
    transform: "translate(9.915 45.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27313-3",
    "data-name": "Rectangle 27313",
    width: 25.983,
    height: 13.375,
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1-3",
    "data-name": "Union 1",
    d: "M8.394,9.782H0L6.4,2.014,10.664,7.2,16.991,0l8.595,9.782Z",
    transform: "translate(10.144 48.72)",
    fill: "rgba(114,112,112,0.19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71671",
    "data-name": "Group 71671",
    transform: "translate(97 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71471-4",
    "data-name": "Group 71471",
    transform: "translate(9.915 45.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27313-4",
    "data-name": "Rectangle 27313",
    width: 25.983,
    height: 13.375,
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1-4",
    "data-name": "Union 1",
    d: "M8.394,9.782H0L6.4,2.014,10.664,7.2,16.991,0l8.595,9.782Z",
    transform: "translate(10.144 48.72)",
    fill: "rgba(114,112,112,0.19)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71680",
    "data-name": "Group 71680",
    transform: "translate(963.756 442.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71592",
    "data-name": "Group 71592",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 6.201,
    cy: 6.201,
    r: 6.201,
    transform: "translate(0 8.769) rotate(-45)",
    fill: "#f0e4e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71593",
    "data-name": "Group 71593",
    transform: "translate(5.502 6.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    d: "M1141.558-1294.513c-1.608-.871-2.49,1.352-2.49,1.352s-.9-2.217-2.5-1.336c-1.808.995-.189,4.207,2.513,5.6C1141.774-1290.307,1143.372-1293.53,1141.558-1294.513Z",
    transform: "translate(-1135.803 1294.715)",
    fill: "#eb908b"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_71693",
    "data-name": "Group 71693",
    transform: "translate(255.766 82.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71681",
    "data-name": "Group 71681",
    transform: "translate(6.382 169.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7404",
    "data-name": "Path 7404",
    d: "M1603.087,921.141s-4.069,5.717-3.511,6.623,4.838,1.035,7.442,0,2.667-7.735,3.845-10.613c.493-1.205-.562-4.762-2.046-5.02a6.029,6.029,0,0,0-3.1.5S1607.257,916.685,1603.087,921.141Z",
    transform: "translate(-1599.523 -912.077)",
    fill: "#363a5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71683",
    "data-name": "Group 71683",
    transform: "translate(8.601 168.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71682",
    "data-name": "Group 71682",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7405",
    "data-name": "Path 7405",
    d: "M1607.825,912.375a27.91,27.91,0,0,0-1.169,4.758c-.259,1.928-2.9,6.021-2.775,6.538s3.473.987,4.837-.348,2.242-5.217,2.543-7.538a19.338,19.338,0,0,1,.633-3.23S1609.128,910.951,1607.825,912.375Z",
    transform: "translate(-1603.877 -911.786)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71684",
    "data-name": "Group 71684",
    transform: "translate(41.945 169.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7406",
    "data-name": "Path 7406",
    d: "M1476.65,921.244s-3.922,5.621-3.364,6.527,4.837,1.035,7.442,0,2.667-7.735,3.845-10.613c.493-1.2-.563-4.762-2.047-5.02a6.426,6.426,0,0,0-3.225.555S1480.821,916.787,1476.65,921.244Z",
    transform: "translate(-1473.231 -912.087)",
    fill: "#363a5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71686",
    "data-name": "Group 71686",
    transform: "translate(44.165 168.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71685",
    "data-name": "Group 71685",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7407",
    "data-name": "Path 7407",
    d: "M1483.6,912.152a39.862,39.862,0,0,1-.806,4.53c-.5,1.877-3.163,6.148-3.039,6.666s3.473.987,4.838-.348,2.419-5.2,2.543-7.538a12.965,12.965,0,0,0-.31-3.864A2.928,2.928,0,0,0,1483.6,912.152Z",
    transform: "translate(-1479.755 -911.335)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71688",
    "data-name": "Group 71688",
    transform: "translate(12.304 64.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71687",
    "data-name": "Group 71687",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7408",
    "data-name": "Path 7408",
    d: "M1474.779,552.242s-3.492,16.951-4.293,21.218-3.047,24.937-3.288,28.452-3.643,16.757-3.483,18.012-5.045,26.47-5.045,26.47a3.029,3.029,0,0,0,3.652.135c.964-.7,11.422-23.606,11.422-29.882,0-8.675,6.147-20,6.94-21.941,7.369-18.031,5.918-23.543,6.881-24.715s1.046.724,1.607,3.318,1.763,25.021,2.485,27.866.161,12.469.563,17.322,2.161,26.808,2.161,26.808,1.363,2.229,3.276.058c.412-.467,3.3-24.456,3.383-30.23s.166-13.737.321-16.234c1.486-23.928,5.137-27.345-.614-44.279C1489.977,522.914,1474.779,552.242,1474.779,552.242Z",
    transform: "translate(-1458.669 -539.884)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71689",
    "data-name": "Group 71689",
    transform: "translate(21.293 71.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7409",
    "data-name": "Path 7409",
    d: "M1485.373,566.939s9.948,14.528,5.665,45.433c0,0-23.595,3.349-36.235-3.873,0,0,5.227-31.864,7.121-36.822S1485.373,566.939,1485.373,566.939Z",
    transform: "translate(-1454.802 -566.938)",
    fill: "#ff5f42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71690",
    "data-name": "Group 71690",
    transform: "translate(17.086 173.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7410",
    "data-name": "Path 7410",
    d: "M1600.316,928.308v5.985h-.744v-4.626Z",
    transform: "translate(-1599.572 -928.308)",
    fill: "#363a5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71691",
    "data-name": "Group 71691",
    transform: "translate(52.651 173.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7411",
    "data-name": "Path 7411",
    d: "M1474.024,928.308v5.985h-.744v-4.626Z",
    transform: "translate(-1473.28 -928.308)",
    fill: "#363a5e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7412",
    "data-name": "Path 7412",
    d: "M1481.134,333.439s-6.662,6.711-4.393,15.352,5.915,8.69,9.933,4.972,6.384-7.627,6.915-11.972S1487.216,327.453,1481.134,333.439Z",
    transform: "translate(-1441.064 -326.035)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    d: "M1493.5,409.6a39.452,39.452,0,0,0,1.68-4.805c.122-.449.235-.906.332-1.362a8.8,8.8,0,0,0,.112-4.26c-1.062-3.138,6.662-.966,6.662-.966s-1.5,8.3,0,11.1S1493.5,409.6,1493.5,409.6Z",
    transform: "translate(-1454.735 -373.372)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7414",
    "data-name": "Path 7414",
    d: "M1481.485,461.848c-.128,1.041-4.993.825-10.183.294,0,.021-.009.041-.014.061-.113.457-.21.866-.28,1.152-.077.313-.146.646-.207,1a26.194,26.194,0,0,0,.512,10.735s-13.082,4.876-21.241.434c0,0,.868-7.1-.434-11.682s-8.111-20.566-8.111-20.566,4.934-7.134,8.7-8.438a63,63,0,0,1,8.618-2.112l7.056.259s5.875,1.53,7.19,1.945c2.35.742,3.259,1.524,4.475,3.95C1479.239,442.212,1482.057,457.16,1481.485,461.848Zm-7.42-7.859s-.643,1.424-1.219,3.032c.47.042.915.045,1.124.076C1475.831,457.376,1474.433,455.015,1474.065,453.989Z",
    transform: "translate(-1419.224 -398.697)",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7415",
    "data-name": "Path 7415",
    d: "M1480.458,337.373s3.186,5.793,5.166,7.869,1.747,3.724,1.747,3.724,7.715-9.517,2.212-15.262-12.6-3.428-14.676,1.593-1.316,11.154-1.316,11.154S1473.651,340.559,1480.458,337.373Z",
    transform: "translate(-1438.216 -325.141)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7416",
    "data-name": "Path 7416",
    d: "M1450.171,318.061s-.771-4.241,5.88-5.928,9.638,5.976,8.819,10.65-6.506,16.53-3.421,18.072,4.289-1.783,4.289-1.783-.964,5.831-5.253,4.482-3.711-10.825-3.064-14.6S1450.171,318.061,1450.171,318.061Z",
    transform: "translate(-1405.827 -311.895)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7417",
    "data-name": "Path 7417",
    d: "M1503.854,407.373a8.118,8.118,0,0,1-6.04,4.532c.122-.449.235-.906.332-1.362C1498.146,410.543,1500.52,411.022,1503.854,407.373Z",
    transform: "translate(-1457.368 -380.485)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7418",
    "data-name": "Path 7418",
    d: "M1470.212,488.142s-.317.669-1.188,3.307a52.847,52.847,0,0,1-.423-11.263A27.847,27.847,0,0,0,1470.212,488.142Z",
    transform: "translate(-1415.465 -432.793)",
    fill: "#cfbeb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7419",
    "data-name": "Path 7419",
    d: "M1476.619,329.967s4.72.907,7.075,4.752c0,0-.478-3.482-2.827-4.485A6.025,6.025,0,0,0,1476.619,329.967Z",
    transform: "translate(-1431.239 -324.69)",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7420",
    "data-name": "Path 7420",
    d: "M1483.515,535.663c-.112.457-.209.866-.28,1.152-.077.313-.146.646-.207,1-2.923-1.59-5.022-2.833-5.022-2.833C1478.793,535.154,1483.515,535.663,1483.515,535.663Z",
    transform: "translate(-1431.451 -472.156)",
    fill: "#cfbeb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7421",
    "data-name": "Path 7421",
    d: "M1504.038,432.133l-8.307,6.771.856-7.133S1501.43,430.725,1504.038,432.133Z",
    transform: "translate(-1456.965 -397.744)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7422",
    "data-name": "Path 7422",
    d: "M1498.659,436.273l-2.4,1.149,8.158-8.087Z",
    transform: "translate(-1457.493 -396.263)",
    fill: "#d6c5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7423",
    "data-name": "Path 7423",
    d: "M1477.432,462.278c-1.143,4.738,3.087,15.4,3.087,15.4l-8.384,2.621a2.148,2.148,0,0,1-2.742-1.6c-1.123-5.218-3.754-18.06-4.069-25.2-.4-9.11,6.232-19.858,6.232-19.858,11.79,2.023,8.558,19.858,8.558,19.858s-.428,1.124-1,2.88h0c-.144.441-.3.922-.454,1.435C1478.255,459.135,1477.821,460.667,1477.432,462.278Z",
    transform: "translate(-1424.878 -399.357)",
    fill: "#494f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7424",
    "data-name": "Path 7424",
    d: "M1541.761,433.113l.145-.39s-6.037.918-9.106,2.451-8.943,9.45-8.943,9.45l7.683,10.144c.009,7.8-1.256,21.655-1.256,21.655l3.513,2.025a1.432,1.432,0,0,0,2.147-1.213c.1-5.271.335-17.786.46-23.847.16-7.8,5.723-20.4,5.723-20.4C1542,433.024,1541.882,433.068,1541.761,433.113Z",
    transform: "translate(-1502.974 -398.697)",
    fill: "#494f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7425",
    "data-name": "Path 7425",
    d: "M1514.405,548.194a65.66,65.66,0,0,0,6.694,0c.9-.225,6.912-2.832,7.273-5.407s-13.968,2.308-13.968,2.308Z",
    transform: "translate(-1486.566 -477.227)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7426",
    "data-name": "Path 7426",
    d: "M1523.71,528.309l-23.51-2.752,10.62,8.641Z",
    transform: "translate(-1477.896 -465.388)",
    fill: "#6a77bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7427",
    "data-name": "Path 7427",
    d: "M1500.635,541.218l12.89-4.393v-1.5L1500.2,539.6Z",
    transform: "translate(-1467.71 -472.408)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71692",
    "data-name": "Group 71692",
    transform: "translate(29.826 58.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7428",
    "data-name": "Path 7428",
    d: "M1530.584,519.291a20.164,20.164,0,0,1-3.034-.221,6.126,6.126,0,0,0-3.471.538c-.533.473-2.231,3.768-2.552,3.969s.164.666.728.433c0,0,.517,1.442,1.794.9s2.145-1.718,2.813-1.926,4.564-1.255,4.564-1.255S1531.587,518.94,1530.584,519.291Z",
    transform: "translate(-1521.425 -519.013)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7429",
    "data-name": "Path 7429",
    d: "M1527.252,428.05l-4.475,7.087-2.16,1.362,5.034-7.057Z",
    transform: "translate(-1487.188 -395.339)",
    fill: "#fae6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7430",
    "data-name": "Path 7430",
    d: "M1520.617,435.137l3.176,1.362.855-7.133.443-1.316Z",
    transform: "translate(-1485.027 -395.339)",
    fill: "#d6c5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7431",
    "data-name": "Path 7431",
    d: "M1578.669,541.045a17.845,17.845,0,0,0,0,3.62s-14.5-1.448-15.85-3.476a8.741,8.741,0,0,1-1.3-4.49Z",
    transform: "translate(-1550.122 -473.393)",
    fill: "#494f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7432",
    "data-name": "Path 7432",
    d: "M1578.9,484.2l-6.855-25.49-26.069-2.752,7.145,23.462Z",
    transform: "translate(-1545.971 -415.388)",
    fill: "#252740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7433",
    "data-name": "Path 7433",
    d: "M1499.2,429.335l-5.758,6.938,3.15,2.809,3.4-8.306Z",
    transform: "translate(-1452.277 -396.263)",
    fill: "#fae6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7434",
    "data-name": "Path 7434",
    d: "M1481,512.257s-.193.586-.193.587c-.144.441-.3.922-.455,1.435-1.112.35-10.742-.356-10.742-.356S1477.67,512.031,1481,512.257Z",
    transform: "translate(-1426.572 -455.82)",
    fill: "#3d426b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7435",
    "data-name": "Path 7435",
    d: "M1455.839,458.8c-1.552-.117-4.093-.282-6.172-.291-3.235-.014-8.769.347-8.769.347l.66,3.457s9.8,1.593,15.156,1.966h0s7.065.811,7.59-.242-.174-7.822-1.323-13.92-2.331-9.61-3.735-11.493-8.827-3.351-8.827-3.351l6.3,20.605a8.522,8.522,0,0,1,.856,2.631c-.014.241-.182.356-.407.4-.159-.014-.507-.044-.988-.081Z",
    transform: "translate(-1401.966 -400.526)",
    fill: "#494f80"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7462",
    "data-name": "Path 7462",
    d: "M1590.174,3599.337c-5.984,1.408-7.125,2.548-8.532,8.532-1.408-5.984-2.549-7.125-8.532-8.532,5.983-1.408,7.125-2.548,8.532-8.532C1583.05,3596.789,1584.191,3597.929,1590.174,3599.337Z",
    transform: "translate(-1573.11 -3590.805)",
    fill: "#ffcc42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M1585.138,3596.819c-4.218.992-5.022,1.8-6.014,6.014-.992-4.218-1.8-5.022-6.014-6.014,4.218-.992,5.022-1.8,6.014-6.014C1580.116,3595.022,1580.92,3595.827,1585.138,3596.819Z",
    transform: "translate(-1260.843 -3536.805)",
    fill: "#ffcc42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImage);
export default __webpack_public_path__ + "static/media/success_image.691cabf100b86074cc037e03a3e21036.svg";
export { ForwardRef as ReactComponent };